export default __webpack_public_path__ + "static/media/Grupo 45@2x.e8e8759c.png";